const { PUBLIC_URL } = process.env;

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string>;
  }
}

const __RUNTIME_CONFIG__ = window.__RUNTIME_CONFIG__;

const __mapAPIKey = __RUNTIME_CONFIG__?.['MAP_API_KEY'] as string;

const Base = __RUNTIME_CONFIG__?.['BASE_API'] as string;

const myBase = __RUNTIME_CONFIG__?.['MY_BASE_API'] as string;

const googleProxyBase = __RUNTIME_CONFIG__?.['GOOGLE_PROXY_BASE'] as string;

const googleProxyApiKey = __RUNTIME_CONFIG__?.[
  'GOOGLE_PROXY_API_KEY'
] as string;

const configList = [
  __mapAPIKey,
  Base,
  myBase,
  googleProxyBase,
  googleProxyApiKey,
];

if (configList.some((item) => typeof item !== 'string')) {
  throw new Error('PLEASE SET ALL CONFIGS');
}

const apiKeyConfig = {
  __PRIVATE_mapAPIKey: __mapAPIKey,
  get mapAPIKey() {
    return apiKeyConfig.__PRIVATE_mapAPIKey;
  },
  set mapAPIKey(v: string) {
    throw new Error('PLEASE USE setMapAPIKey to mutate mapAPIKey');
  },
  setMapAPIKey: (v: string) => {
    apiKeyConfig.__PRIVATE_mapAPIKey = v;
  },
};

const mapAPIKey = apiKeyConfig.mapAPIKey;

const setMapAPIKey = apiKeyConfig.setMapAPIKey;

export {
  Base,
  PUBLIC_URL,
  googleProxyApiKey,
  googleProxyBase,
  mapAPIKey,
  setMapAPIKey,
  myBase,
};
